<template>
  <form @submit.prevent="onSubmit">
    <div class="form-group">
      <label for="email">Email Address</label>
      <input v-model="email" type="email" class="form-control" id="email" name="email" disabled>
    </div>

    <div class="form-group">
      <label for="first-name">First Name</label>
      <input v-model="firstName" type="text" class="form-control" id="first-name" name="first-name"/>
    </div>

    <div class="form-group">
      <label for="last-name">Last Name</label>
      <input v-model="lastName" type="text" class="form-control" id="last-name" name="last-name"/>
    </div>

    <div class="form-group">
      <label for="company-name">Company Name</label>
      <input v-model="companyName" type="text" class="form-control" id="company-name" name="company-name"/>
    </div>

    <registration-form-broker-dealer v-if="!shouldUseDefaultBrokerDealer && brokerDealerEnabled"
                                     v-model="brokerDealerId" :broker-dealers="brokerDealers"
                                     :label="brokerDealerLabel"/>

    <div v-if="globalError" class="alert alert-danger mt-5" role="alert">
      {{ globalError }}
    </div>

    <div class="text-center py-3">
      <button :disabled="!formValid || loading" type="submit" class="btn btn-primary btn-lg">
        {{ loading ? 'Saving...' : 'Save' }}
      </button>
    </div>
  </form>
</template>

<script>
import RegistrationFormBrokerDealer from './RegistrationFormBrokerDealer.vue';

export default {
  name: 'registration-form-sso',
  components: {RegistrationFormBrokerDealer},
  props: {
    brokerDealerEnabled: {
      type: Boolean,
    },
    brokerDealerLabel: {
      type: String,
    },
    brokerDealers: {
      type: Array,
    },
    shouldUseDefaultBrokerDealer: {
      type: Boolean,
    },
    globalError: {
      type: String,
    },
    loading: {
      type: Boolean,
    },
    email: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      companyName: '',
      brokerDealerId: '',
      textSecurity: CSS.supports('(-webkit-text-security: disc)'),
    };
  },
  computed: {
    brokerDealerValid() {
      return !this.brokerDealerEnabled || this.brokerDealerId;
    },
    companyNameValid() {
      return this.companyName.length > 0;
    },
    firstNameValid() {
      return this.firstName.length > 0;
    },
    formValid() {
      return (
        this.firstNameValid &&
        this.lastNameValid &&
        this.companyNameValid &&
        this.brokerDealerValid
      );
    },
    lastNameValid() {
      return this.lastName.length > 0;
    },
  },
  methods: {
    onSubmit() {
      if (!this.formValid) {
        return;
      }

      this.$emit('submit', {
        firstName: this.firstName,
        lastName: this.lastName,
        companyName: this.companyName,
        brokerDealerId: this.brokerDealerEnabled ? this.brokerDealerId : undefined,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.text-security-disc {
  -webkit-text-security: disc;
}
</style>
